import React, { useCallback, useMemo, ReactNode } from 'react';
import { ListView } from 'antd-mobile';
import { get } from 'lodash';
import Empty from '@/components/EmptyItem';
import { truncateString } from '@/utils';
import searchTableListEmpty from '@/assets/images/searchTableListEmpty.png';
import styles from './index.less';

export type ColumnsType = {
  title: ReactNode;
  dataIndex: string | number | readonly (string | number)[];
};

export type SearchTableListProps = {
  dataSource: Record<string, any>[];
  columns: ColumnsType[];
  letter?: string
};

const listDataSource = new ListView.DataSource({
  rowHasChanged: (row1: any, row2: any) => row1 !== row2,
});

const SearchTableList = (props: SearchTableListProps) => {
  const { columns, dataSource, letter } = props;

  const Header = useCallback(() => {
    return (
      <div className={styles.header}>
        <div className={styles.headerContent}>
          {columns?.map((column: ColumnsType, index: number) => {
            return (
              <div className={styles.title} key={`${column.dataIndex}_${index}`}>
                {column.title}
              </div>
            );
          })}
        </div>
      </div>
    );
  }, [columns]);

  const renderRow = useCallback(
    (rowData: any, sectionID: string | number, rowID: string | number) => {
      return (
        <div className={styles.row}>
          <div className={styles.rowContent}>
            {columns?.map((column: ColumnsType, index: number) => {
              return (
                <div className={styles.text} key={`${column.dataIndex}_${rowID}_${index}`}>
                  {truncateString(get(rowData, column.dataIndex))}
                </div>
              );
            })}
          </div>
        </div>
      );
    },
    [columns, dataSource],
  );

  const numRows = useMemo(() => dataSource?.length || 0, [dataSource]);

  return (
    <div className={styles.searchTableList}>
      <Header />

      {!!dataSource?.length && (
        <ListView
          dataSource={listDataSource.cloneWithRows(dataSource)}
          renderRow={renderRow}
          style={{ height: 'calc(100% - 1.16rem)' }}
          scrollEventThrottle={16}
          initialListSize={numRows}
          pageSize={numRows}
          useBodyScroll={false}
        />
      )}

      {!dataSource?.length && <Empty img={searchTableListEmpty} letter={letter}/>}
    </div>
  );
};

export default SearchTableList;
